<div style="margin: 20px; width:100%" *ngIf="linkValido">

    <ng-container *ngIf="unaEmpresa">
        <div class="header  p-24 " [ngClass]="{'header_HPTW': selectInstituto == 23, 'accent': selectInstituto != 23}" fxLayout="row" fxLayoutAlign="start center">

            <ng-container>
                <h2 class="m-0 product_name2" style="padding-right: 10px!important;">{{'PORTAL.PRODUCTO.PORTAL' | translate}}</h2>
                <h2 class="m-0 product_name2">{{'PORTAL.PRODUCTO.NAME' | translate}} {{nombreEmpresaFinal}}</h2>
                <!--<h2 class="m-0 product_name"> {{'PORTAL.PRODUCTO.PRODUCTO' | translate}} {{this.translate_name}}</h2>-->
            </ng-container>

        </div>
        <!-- muestra cuando el instituto no es IZZI-->
      <div fxLayout="row" fxLayoutAlign="end end">
        <button mat-raised-button class="mb-20 " [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" (click)="downloadImage()">>
          {{'PORTAL.BTN_SCREE_SHO' | translate}}
          <mat-icon class="ml-20">center_focus_weak</mat-icon>
        </button>
      </div>
        <ng-container *ngIf="!validarIzzi && selectInstituto!=14">
          <div #screen *ngIf="!visualizarCards && conteosClaves || statusNorma" class="" fxLayout="row" fxLayoutAlign="space-between" style="width:100%"  >
          <!-- <div #screen *ngIf="!visualizarCards && conteosClaves || statusNorma" class="divTarjetas"> -->
            <!-- Total Usuarios -->
            <div class="mat-elevation-z2 p-20 m-20 tarjeta totalCol" [ngClass]="{'totalCol_HPTW': selectInstituto == 23}" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <!-- CONTESO NORMAL -->
                  <h1 *ngIf="tipoPersonalSeleccionado==1" style="margin-top:0px">{{conteosClaves.avance.totalUsers}}</h1>
                  <h1 *ngIf="tipoPersonalSeleccionado==2" style="margin-top:0px">{{conteosClaves2Empresa.avance.totalUsers}}</h1>
                  <!-- <img #screen  class="imgtotalCol" src="{{urlImagenLog}}logos/total-users.png" alt="" fxLayoutAlign="center center"> -->
                  <img  class="imgtotalCol" src="./assets/images/logos/total-users.png" alt="" fxLayoutAlign="center center">
                  <mat-divider></mat-divider>
                  <div style="margin-top:80px" class="texto">{{'PORTAL.TOTALCOLA' | translate}}</div>
            </div>
            <!-- Total Usuarios  queno han contestado-->
            <div class="mat-elevation-z2 p-20 m-20 tarjeta totalFal" [ngClass]="{'totalFal_HPTW': selectInstituto == 23}" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <!-- CONTESO NORMAL -->
                  <h1 *ngIf="tipoPersonalSeleccionado==1" style="margin-top:0px">{{conteosClaves.avance.totalUsers-conteosClaves.avance.endUsers}}</h1>
                  <h1 *ngIf="tipoPersonalSeleccionado==2" style="margin-top:0px">{{conteosClaves2Empresa.avance.totalUsers-conteosClaves2Empresa.avance.endUsers}}</h1>
                  <!-- <img class="imgtotalCol" src="{{urlImagenLog}}logos/users-not-responded.png" alt="" fxLayoutAlign="center center"> -->
                  <img  class="imgtotalCol" src="./assets/images/logos/users-not-responded.png" alt="" fxLayoutAlign="center center">
                  <mat-divider></mat-divider>
                  <div style="margin-top:80px" class="texto">{{'PORTAL.TOTALFAL' | translate}}</div>
            </div>
            <!-- Total Usuarios  que ya han contestado-->
            <div class="mat-elevation-z2 p-20 m-20 tarjeta totalCom" [ngClass]="{'totalCom_HPTW': selectInstituto == 23}" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <!-- CONTEOS NORMAL -->
                  <h1 *ngIf="tipoPersonalSeleccionado==1" style="margin:0px">{{conteosClaves.avance.endUsers}}</h1>
                  <h1 *ngIf="tipoPersonalSeleccionado==2" style="margin:0px">{{conteosClaves2Empresa.avance.endUsers}}</h1>
                  <!-- <img class="imgtotalCol" src="{{urlImagenLog}}logos/users-have-responded.png" alt="" fxLayoutAlign="center center"> -->
                  <img  class="imgtotalCol" src="./assets/images/logos/users-have-responded.png" alt="" fxLayoutAlign="center center">
                  <mat-divider></mat-divider>
                  <div style="margin-top:80px" class="texto">{{'PORTAL.TOTALCONT' | translate}}</div>
            </div>
            <!-- Caja total de porcentaje de avance -->
            <div class="mat-elevation-z2 p-20 m-20 tarjeta totalPro" [ngClass]="{'totalPro_HPTW': selectInstituto == 23}" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
                  <h1 *ngIf="tipoPersonalSeleccionado==1" style="margin:0px">{{conteosClaves.avance.porcentaje}} %</h1>
                  <h1 *ngIf="tipoPersonalSeleccionado==2" style="margin:0px">{{conteosClaves2Empresa.avance.porcentaje}} %</h1>
                  <!-- <img class="imgtotalCol" src="{{urlImagenLog}}logos/meta.png" alt="" fxLayoutAlign="center center"> -->
                  <img  class="imgtotalCol" src="./assets/images/logos/meta.png" alt="" fxLayoutAlign="center center">
                  <mat-divider></mat-divider>
                  <div style="margin-top:80px" class="texto">{{'PORTAL.TOTALPRO' | translate}}</div>
            </div>
            <!--REPORTE-->
            <ng-container *ngIf="resultsBoxEntregables">
              <div class="mat-elevation-z2 p-20 m-20 tarjeta reporte" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto==1 && idProductoCertificares==1 || tipoProducto==1 && idProductoCertificares==20 ||tipoProducto==1 && idProductoCertificares==40 ||idProductoCertificares==41">
                    <h1 style="margin:0px">{{respRecRes}} {{'PORTAL.COLAB' | translate}}</h1>
                     <!-- <img class="imgtotalCol" src="{{urlImagenLog}}logos/report.png" alt="" fxLayoutAlign="center center"> -->
                     <img  class="imgtotalCol" src="./assets/images/logos/report.png" alt="" fxLayoutAlign="center center">
                    <mat-divider></mat-divider>
                    <button  class="btnverMas texto"  matTooltipClass="tooltip" matTooltip="{{textToolResultsBoxEntregables | translate}}" matTooltipPosition="below">{{textResultsBoxEntregables | translate}}</button>
              </div>
              <!--RANKING-->
            </ng-container>
            <ng-container *ngIf="resultsBoxRanking">
              <div class="mat-elevation-z2 p-20 m-20 tarjeta ranking" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto==1 && idProductoCertificares==1 || tipoProducto==1 && idProductoCertificares==20 ||tipoProducto==1 && idProductoCertificares==40 ||idProductoCertificares==41">
                    <h1 style="margin:0px">{{respMinCer}} {{'PORTAL.COLAB' | translate}}</h1>
                    <!-- <img class="imgtotalCol" src="{{urlImagenLog}}logos/ranking.png" alt="" fxLayoutAlign="center center"> -->
                    <img  class="imgtotalCol" src="./assets/images/logos/ranking.png" alt="" fxLayoutAlign="center center">
                    <mat-divider></mat-divider>
                    <button  class="btnverMasRanking texto" matTooltipClass="tooltipRanking" matTooltip="{{textToolResultsBoxRanking | translate}}" matTooltipPosition="below">{{textResultsBoxRanking | translate}}</button>
              </div>
            </ng-container>

          </div>
        </ng-container>

        <!-- muestra cuando el instituto es IZZI-->
        <ng-container *ngIf="validarIzzi || selectInstituto==14">
          <div *ngIf="!visualizarCards && conteosClaves || statusNorma" class="" fxLayout="row" fxLayoutAlign="space-between" #screen>
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <!-- CONTEOS IZZI -->
              <div *ngIf="validarIzzi || selectInstituto==14" class="mat-elevation-z2 p-20 m-20 tarjeta totalColIzzi" fxLayout="column" fxLayoutAlign="space-between stretch" he>
                <div class="">
                  <!--<h1>{{infoAvanceConteo.avance.totalUsers}}</h1>-->
                  <h1>{{conteosClaves.avance.totalUsers}}</h1>
                </div>
                <div class="">
                  <mat-divider></mat-divider>
                  <div class="mt-20">
                    <div class="texto">{{'PORTAL.TOTALCOLA' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <!-- CONTEOS IZZI -->
              <div *ngIf="validarIzzi || selectInstituto==14" class="mat-elevation-z2 p-20 m-20 tarjeta totalFalIzzi" fxLayout="column" fxLayoutAlign="space-between stretch">
                <div class="">
                  <!--<h1>{{infoAvanceConteo.avance.totalUsers-infoAvanceConteo.avance.endUsers}}</h1>-->
                  <h1>{{conteosClaves.avance.totalUsers-conteosClaves.avance.endUsers}}</h1>
                </div>
                <div class="">
                  <mat-divider></mat-divider>
                  <div class="mt-20">
                    <div class="texto">{{'PORTAL.TOTALFAL' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <!-- CONTEOS IZZI -->
              <div *ngIf="validarIzzi || selectInstituto==14" class="mat-elevation-z2 p-20 m-20 tarjeta totalComIzzi" fxLayout="column" fxLayoutAlign="space-between stretch">
                <div class="">
                  <!--<h1>{{infoAvanceConteo.avance.endUsers}}</h1>-->
                  <h1>{{conteosClaves.avance.endUsers}}</h1>
                </div>
                <div class="">
                  <mat-divider></mat-divider>
                  <div class="mt-20">
                    <div class="texto">{{'PORTAL.TOTALCONT' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <!-- CONTEOS IZZI -->
              <div *ngIf="validarIzzi || selectInstituto==14" class="mat-elevation-z2 p-20 m-20 tarjeta totalProIzzi" fxLayout="column" fxLayoutAlign="space-between stretch">
                <div class="">
                  <h1>{{conteosClaves.avance.porcentaje}} %</h1>

                </div>
                <div class="">
                  <mat-divider></mat-divider>
                  <div class="mt-20">
                    <div class="texto">{{'PORTAL.TOTALPRO' | translate}}</div>
                  </div>
                </div>

              </div>
            </div>


            <!-- <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto==1">
              <div class="mat-elevation-z2 p-20 m-20 tarjeta totalLog" fxLayout="column" fxLayoutAlign="space-between stretch">
                <div class="">
                  <h1>{{conteosClaves.avance.porcentaje}} %</h1>

                </div>
                <div class="">
                  <mat-divider></mat-divider>
                  <div class="mt-20">
                    <div class="texto">{{'PORTAL.TOTALLOG' | translate}}</div>
                  </div>
                </div>

              </div>
            </div> -->
            <!--REPORTE-->
            <ng-container *ngIf="resultsBoxEntregables">
              <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto==1 && idProductoCertificares==1 || tipoProducto==1 && idProductoCertificares==20 ||tipoProducto==1 && idProductoCertificares==40">
                <div class="mat-elevation-z2 p-20 m-20 tarjeta reporte" fxLayout="column" fxLayoutAlign="space-between stretch">
                  <div class="">
                    <h1>{{respRecRes}} {{'PORTAL.COLAB' | translate}}</h1>
                  </div>
                  <div class="">
                    <mat-divider></mat-divider>
                    <div class="mt-20">
                      <button  class="btnverMas texto"  matTooltipClass="tooltip" matTooltip="{{textToolResultsBoxEntregables | translate}}" matTooltipPosition="below">{{textResultsBoxEntregables | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
              <!--RANKING-->
            </ng-container>
            <ng-container *ngIf="resultsBoxRanking">
              <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto==1 && idProductoCertificares==1 || tipoProducto==1 && idProductoCertificares==20 ||tipoProducto==1 && idProductoCertificares==40 ||idProductoCertificares==41">
                <div class="mat-elevation-z2 p-20 m-20 tarjeta ranking" fxLayout="column" fxLayoutAlign="space-between stretch">
                  <div class="">
                    <!--<h1>{{infoAvanceConteo.avance.porcentaje}} %</h1>-->
                    <h1>{{respMinCer}} {{'PORTAL.COLAB' | translate}}</h1>
                  </div>
                  <div class="">
                    <mat-divider></mat-divider>
                    <div class="mt-20">
                      <!-- <div class="texto">{{textResultsBoxRanking | translate}}</div> -->
                      <button  class="btnverMasRanking texto" matTooltipClass="tooltipRanking" matTooltip="{{textToolResultsBoxRanking | translate}}" matTooltipPosition="below">{{textResultsBoxRanking | translate}}</button>
                    </div>
                  </div>

                </div>
              </div>
            </ng-container>

          </div>
        </ng-container>


        <!-- <div   class="mt-20" fxLayout="row" fxLayoutAlign="end">
        <div class="" fxLayout="column" fxLayoutAlign="start end" fxFlex="50">
        <button mat-raised-button class="mb-20 primary" (click)="infoExcel()">
      {{'PORTAL.EXCEL.NOMBOTON' | translate}}
        <mat-icon class="ml-20">cloud_download</mat-icon>
      </button>

    </div>
    </div> -->
        <ng-container *ngIf="empresasExisten2">
            <mat-form-field appearance="outline">
                <mat-label>{{'PORTAL.TIPO-PERSONAL.TIPO'| translate}}</mat-label>
                <mat-select [(value)]="tipoPersonalSeleccionado" (selectionChange)="selecTipoDePortal()">
                    <mat-option *ngFor="let tipoPersonal of tipoPersonal" [value]="tipoPersonal.value">
                        {{'PORTAL.TIPO-PERSONAL.'+tipoPersonal.value | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>



        <!-- <div class="" fxLayout="row" fxLayoutAlign="start stretch" *ngIf="datosEncontrados && !visualizarCards">
            <canvas baseChart fxFlex="80" height="150px" [labels]="barChartLabels" [datasets]="bubbleChartData" [options]="bubbleChartOptions" [colors]="bubbleChartColors" [legend]="bubbleChartLegend" [chartType]="bubbleChartType">
      </canvas>
        </div> -->
        <ng-container *ngIf="!fechaAnterior">
          <div class="" fxLayout="row" fxLayoutAlign="start stretch" *ngIf="datosEncontrados && !visualizarCards">
            <canvas baseChart fxFlex="100" height="100px" [labels]="lineChartLabels" [datasets]="lineChartData" [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType">
            </canvas>
          </div>
        </ng-container>



        <!-- TABLA NUEVO DE FILTROS -->
        <ng-container *ngIf="cargandoTablaFiltros">
            <div class="mt-20" fxLayout="column" fxLayoutAlign="space-between center">
                <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
            </div>
        </ng-container>

        <mat-tab-group *ngIf="!cargandoTablaFiltros && !statusNorma" (selectedTabChange)="onLinkClick($event)">
            <mat-tab label="{{'PORTAL.PORTAL_V1' | translate}}">
              <div class="btnFltros" fxLayout="row" fxLayoutAlign="start center" fxFlex="50">
                  <button mat-raised-button class="mb-20" [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" (click)="descargarExcelReducido()" *ngIf="!statusNorma">
            {{'PORTAL.EXCEL.NOMBOTON' | translate}}
            <mat-icon class="ml-20">cloud_download</mat-icon>
            </button>
              </div>
                <div class="mat-elevation-z8" *ngIf="!cargandoTablaFiltros && !statusNorma">
                    <table mat-table [dataSource]="filtroPortalv2Reducido">

                        <!-- DEMOGRAFICO -->
                        <ng-container matColumnDef="demografico">
                            <th mat-header-cell *matHeaderCellDef>{{'PORTAL.COLUMNAS_TABLA.DEMOGRAFICO' | translate}}
                                <button mat-mini-fab [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
               <mat-icon>filter_list</mat-icon>
               </button>
                                <mat-menu #menu="matMenu" class="matMenuFiltros">
                                    <button mat-menu-item (click)="seleccionarFiltroReducido('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                                    <button mat-menu-item *ngFor="let item of catalogoFiltrosReducido" (click)="seleccionarFiltroReducido(item)">
                                      <p *ngIf="selectInstituto!=3">{{'PORTAL.FILTROS_V2.'+item | translate}}</p>
                                      <p *ngIf="selectInstituto==3">{{'PORTAL.FILTROS_V2_HK.'+item | translate}}</p>
                                    </button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;">

                              <p *ngIf="selectInstituto!=3">{{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}}</p>
                              <p *ngIf="selectInstituto==3">{{'PORTAL.FILTROS_V2_HK.'+element.FILTRO | translate}}</p>
                             </td>
                        </ng-container>

                        <!-- SEGMENTO -->
                        <ng-container matColumnDef="segmento">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.SEGMENTO' | translate}}
                                <button mat-mini-fab [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
               <mat-icon>filter_list</mat-icon>
               </button>
                                <mat-menu #menu="matMenu" class="matMenuFiltros">
                                    <button mat-menu-item (click)="seleccionarFiltroReducido2('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                                    <button mat-menu-item *ngFor="let item of catalogoFiltrosSegmentoReducido" (click)="seleccionarFiltroReducido2(item)">{{item}}</button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.SEGMENTO}} </td>
                        </ng-container>

                        <!-- COLABORADORES TOTALES -->
                        <ng-container matColumnDef="colaboradoresTotales">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.COLABORADORES_T' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="width: 10%;"> {{element.TOTAL_DE_COLABORADORES}} </td>
                        </ng-container>

                        <!-- PENDIENTES POR RESPONDER -->
                        <ng-container matColumnDef="pendientesResponder">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.PENDIENTES_RESPONDER' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.COLABORADORES_QUE_AUN_NO_RESPONDEN}} </td>
                        </ng-container>

                        <!-- YA RESPONDIERON -->
                        <ng-container matColumnDef="respondieron">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.YA_RESPONDIERON' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.COLABORADORES_QUE_YA_RESPONDIERON}} </td>
                        </ng-container>

                        <!-- AVANCE -->
                        <ng-container matColumnDef="avance">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.AVANCE' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="width: 100%;">
                                <div *ngIf="element.COLABORADORES_QUE_YA_RESPONDIERON!='*' || element.COLABORADORES_QUE_AUN_NO_RESPONDEN!='*'" class="" fxLayout="column" fxLayoutAlign="center center" fxFlex.gt-sm="90"> <br>
                                    <mat-progress-bar class="prro" [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" mode="buffer" value="{{(element.PROGRESO_TOTAL*100).toFixed(2)}}"></mat-progress-bar>
                                    <p class="mt-0 mb-10 midTextV2">{{(element.PROGRESO_TOTAL*100).toFixed(2)}}%</p>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsReducido"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsReducido;"></tr>
                    </table>
                </div>
            </mat-tab>

            <mat-tab label="{{'PORTAL.PORTAL_V2' | translate}}">
                <div class="btnFltros" fxLayout="row" fxLayoutAlign="start center" fxFlex="50">
                    <button mat-raised-button class="mb-20" [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" (click)="seleccionarFiltro('');
         seleccionarFiltro2('');
         seleccionarFiltro3('');
         seleccionarFiltro4('');">
         {{'PORTAL.ETIQUETAS.BOTON' | translate}}
        </button> &nbsp;
        <button mat-raised-button class="mb-20" [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" (click)="descargarExcelV2()" *ngIf="!statusNorma">
        {{'PORTAL.EXCEL.NOMBOTON' | translate}}
        <mat-icon class="ml-20">cloud_download</mat-icon>
        </button>
                </div>
                <div class="mat-elevation-z8" *ngIf="!cargandoTablaFiltros && !statusNorma">
                    <table mat-table [dataSource]="filtroPortalv2">

                        <!-- NIVEL 1 -->
                        <ng-container matColumnDef="nivel1">
                            <th mat-header-cell *matHeaderCellDef>{{'PORTAL.COLUMNAS_TABLA.NIVEL1' | translate}}
                                <button mat-mini-fab [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
             <mat-icon>filter_list</mat-icon>
             </button>
                                <mat-menu #menu="matMenu" class="matMenuFiltros">
                                    <button mat-menu-item (click)="seleccionarFiltro('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                                    <button mat-menu-item *ngFor="let item of catalogoFiltrosN1" (click)="seleccionarFiltro(item)">{{item}}</button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.Nivel_1}} </td>
                        </ng-container>

                        <!-- NIVEL 2 -->
                        <ng-container matColumnDef="nivel2">
                            <th mat-header-cell *matHeaderCellDef>{{'PORTAL.COLUMNAS_TABLA.NIVEL2' | translate}}
                                <button mat-mini-fab [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
             <mat-icon>filter_list</mat-icon>
             </button>
                                <mat-menu #menu="matMenu" class="matMenuFiltros">
                                    <button mat-menu-item (click)="seleccionarFiltro2('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                                    <button mat-menu-item *ngFor="let item of catalogoFiltrosN2" (click)="seleccionarFiltro2(item)">{{item}}</button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.Nivel_2}} </td>
                        </ng-container>

                        <!-- DEMOGRAFICO -->
                        <ng-container matColumnDef="demografico">
                            <th mat-header-cell *matHeaderCellDef>{{'PORTAL.COLUMNAS_TABLA.DEMOGRAFICO' | translate}}
                                <button mat-mini-fab [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
             <mat-icon>filter_list</mat-icon>
             </button>
                                <mat-menu #menu="matMenu" class="matMenuFiltros">
                                    <button mat-menu-item (click)="seleccionarFiltro3('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                                    <button mat-menu-item *ngFor="let item of catalogoFiltros" (click)="seleccionarFiltro3(item)">
                                      <ng-container *ngIf="item==nombreEmpresaFinal">
                                        {{item}}
                                      </ng-container>
                                      <ng-container *ngIf="item!=nombreEmpresaFinal">
                                        {{'PORTAL.FILTROS_V2.'+item | translate}}
                                      </ng-container>
                                    </button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;">
                            <ng-container *ngIf="element.nivel1==Company">
                              <ng-container *ngIf="element.FILTRO==nombreEmpresaFinal">
                                {{element.FILTRO}}
                              </ng-container>
                              <ng-container *ngIf="element.FILTRO!=nombreEmpresaFinal">
                                {{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}}
                              </ng-container>
                                  <!-- {{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}} -->
                            </ng-container>
                            <ng-container *ngIf="element.nivel1!=Company">
                              <ng-container *ngIf="element.FILTRO==nombreEmpresaFinal">
                                {{element.FILTRO}}
                              </ng-container>
                              <ng-container *ngIf="element.FILTRO!=nombreEmpresaFinal">
                                {{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}}
                              </ng-container>
                              <!-- {{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}} -->
                            </ng-container>
                            </td>
                            <!-- <td mat-cell *matCellDef="let element" style="width: 13%;"> {{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}} </td> -->
                        </ng-container>

                        <!-- SEGMENTO -->
                        <ng-container matColumnDef="segmento">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.SEGMENTO' | translate}}
                                <button mat-mini-fab [ngClass]="{'primary_HPTW': selectInstituto == 23, 'primary': selectInstituto != 23}" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
             <mat-icon>filter_list</mat-icon>
             </button>
                                <mat-menu #menu="matMenu" class="matMenuFiltros">
                                    <button mat-menu-item (click)="seleccionarFiltro4('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                                    <button mat-menu-item *ngFor="let item of catalogoFiltrosSegmento" (click)="seleccionarFiltro4(item)">{{item}}</button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.SEGMENTO}} </td>
                        </ng-container>

                        <!-- COLABORADORES TOTALES -->
                        <ng-container matColumnDef="colaboradoresTotales">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.COLABORADORES_T' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="width: 10%;"> {{element.TOTAL_DE_COLABORADORES}} </td>
                        </ng-container>

                        <!-- PENDIENTES POR RESPONDER -->
                        <ng-container matColumnDef="pendientesResponder">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.PENDIENTES_RESPONDER' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.COLABORADORES_QUE_AUN_NO_RESPONDEN}} </td>
                        </ng-container>

                        <!-- YA RESPONDIERON -->
                        <ng-container matColumnDef="respondieron">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.YA_RESPONDIERON' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.COLABORADORES_QUE_YA_RESPONDIERON}} </td>
                        </ng-container>

                        <!-- AVANCE -->
                        <ng-container matColumnDef="avance">
                            <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.AVANCE' | translate}} </th>
                            <td mat-cell *matCellDef="let element" style="width: 100%;">
                                <div *ngIf="element.COLABORADORES_QUE_YA_RESPONDIERON!='*' || element.COLABORADORES_QUE_AUN_NO_RESPONDEN!='*'" class="" fxLayout="column" fxLayoutAlign="center center" fxFlex.gt-sm="90"> <br>
                                    <mat-progress-bar class="prro" mode="buffer" value="{{(element.PROGRESO_TOTAL*100).toFixed(2)}}"></mat-progress-bar>
                                    <p class="mt-0 mb-10 midTextV2">{{(element.PROGRESO_TOTAL*100).toFixed(2)}}%</p>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 25, 100, 500]" showFirstLastButtons style="margin-bottom: 250px;"></mat-paginator>
                </div>
            </mat-tab>
        </mat-tab-group>

        <!-- TERMINA TABLA NUEVA DE FILTROS -->


        <div class="" fxLayout="column" fxLayoutAlign="start stretch">

            <div class="" fxLayout="row" fxLayoutAlign="center">
                <h1 *ngIf="!portalValidacion">{{nombre}}</h1>
            </div>
            <div class="" fxLayout="column" fxLayoutAlign="space-between">
                <ng-container *ngIf="cargandoFiltros">
                    <div class="mt-20" fxLayout="column" fxLayoutAlign="space-between center">
                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                        <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
                    </div>
                </ng-container>
                <ng-container *ngIf="resultadoConteo && !cargandoFiltros && !portalValidacion">

                    <div *ngFor="let resultado of resultadoConteo.resultado" fxLayout="column" fxLayoutAlign="" fxFlex="50">
                        <ng-container *ngIf="!mensaje">
                            <h3>{{resultado.filtro}}</h3>
                            <div class="" fxLayout="row" fxLayoutAlign="start start">
                                <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="90">
                                    <mat-progress-bar *ngIf="!validarIzzi && selectInstituto!=14" class="prro" mode="buffer" value="{{resultado.porcentaje}}"></mat-progress-bar>
                                    <mat-progress-bar *ngIf="validarIzzi" class="izzi" mode="buffer" value="{{resultado.porcentaje}}"></mat-progress-bar>
                                    <mat-progress-bar *ngIf="selectInstituto==14" class="gcti" mode="buffer" value="{{resultado.porcentaje}}"></mat-progress-bar>
                                    <h4 class="mt-0 mb-10 midText">{{'PORTAL.TBARRAPROGRESO' | translate}}: {{resultado.porcentaje}}%</h4>
                                </div>
                                <h3 class="mt-0 ml-10 tamañoletra">[{{resultado.endUsers}}/{{resultado.totalUsers}}]</h3>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="mensaje">
                    <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center">
                        <h1 class="h1 secondary-text">
                            <p class="textoN">{{'PORTAL.NO-INFO' | translate}}</p>
                        </h1>
                    </div>
                </ng-container>
            </div>


        </div>

    </ng-container>
    <ng-container *ngIf="!unaEmpresa">

        <div *ngIf="conteosClaves" class="" fxLayout="row" fxLayoutAlign="space-between">
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
                <!-- CONTESO NORMAL -->
                <div *ngIf="!validarIzzi && selectInstituto!=14" class="mat-elevation-z2 p-20 m-20 tarjeta totalCol" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="">
                        <!--<h1>{{infoAvanceConteo.avance.totalUsers}}</h1>-->
                        <h1 *ngIf="!empresasBaxter">{{totalColaboradores2Empresas}}</h1>
                        <h1 *ngIf="empresasBaxter">{{totalColaboradores2Empresas}}</h1>
                    </div>
                    <div class="">
                        <mat-divider></mat-divider>
                        <div class="mt-20">
                            <div class="texto">{{'PORTAL.TOTALCOLA' | translate}}</div>
                        </div>
                    </div>
                </div>
                <!-- CONTEOS IZZI -->
                <div *ngIf="validarIzzi || selectInstituto==14" class="mat-elevation-z2 p-20 m-20 tarjeta totalColIzzi" fxLayout="column" fxLayoutAlign="space-between stretch" he>
                    <div class="">
                        <!--<h1>{{infoAvanceConteo.avance.totalUsers}}</h1>-->
                        <h1>{{conteosClaves.avance.totalUsers}}</h1>
                    </div>
                    <div class="">
                        <mat-divider></mat-divider>
                        <div class="mt-20">
                            <div class="texto">{{'PORTAL.TOTALCOLA' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
                <!-- CONTESO NORMAL -->
                <div *ngIf="!validarIzzi && selectInstituto!=14" class="mat-elevation-z2 p-20 m-20 tarjeta totalFal" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="">
                        <!--<h1>{{infoAvanceConteo.avance.totalUsers-infoAvanceConteo.avance.endUsers}}</h1>-->
                        <h1>{{totalColaboradores2Empresas-totalColaboradoresFinalizaron2Empresas}}</h1>
                    </div>
                    <div class="">
                        <mat-divider></mat-divider>
                        <div class="mt-20">
                            <div class="texto">{{'PORTAL.TOTALFAL' | translate}}</div>
                        </div>
                    </div>
                </div>
                <!-- CONTEOS IZZI -->

            </div>
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
                <!-- CONTEOS NORMAL -->
                <div *ngIf="!validarIzzi || selectInstituto==14" class="mat-elevation-z2 p-20 m-20 tarjeta totalCom" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="">
                        <!--<h1>{{infoAvanceConteo.avance.endUsers}}</h1>-->
                        <h1>{{totalColaboradoresFinalizaron2Empresas}}</h1>
                    </div>
                    <div class="">
                        <mat-divider></mat-divider>
                        <div class="mt-20">
                            <div class="texto">{{'PORTAL.TOTALCONT' | translate}}</div>
                        </div>
                    </div>
                </div>
                <!-- CONTEOS IZZI -->

            </div>
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
                <!-- CONTEOS NORMAL -->
                <div *ngIf="!validarIzzi && selectInstituto!=14" class="mat-elevation-z2 p-20 m-20 tarjeta totalPro" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="">
                        <h1>{{totalPorcentaje2Empresas | number:'1.0-0'}} %</h1>

                    </div>
                    <div class="">
                        <mat-divider></mat-divider>
                        <div class="mt-20">
                            <div class="texto">{{'PORTAL.TOTALPRO' | translate}}</div>
                        </div>
                    </div>

                </div>
                <!-- CONTEOS IZZI -->

            </div>


            <!-- <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto==1">
            <div class="mat-elevation-z2 p-20 m-20 tarjeta totalLog" fxLayout="column" fxLayoutAlign="space-between stretch">
                <div class="">
                    <h1>{{conteosClaves.avance.porcentaje}} %</h1>

                </div>
                <div class="">
                    <mat-divider></mat-divider>
                    <div class="mt-20">
                        <div class="texto">{{'PORTAL.TOTALLOG' | translate}}</div>
                    </div>
                </div>

            </div>
        </div> -->
            <!--REPORTE-->
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto==1 && instituto==1 || tipoProducto==1 && instituto==2">
                <div class="mat-elevation-z2 p-20 m-20 tarjeta reporte" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="">
                        <h3>{{conteosClaves.avance.totalUsers*85/100 | number:'1.0-0' }} {{'PORTAL.COLAB' | translate}}</h3>


                    </div>
                    <div class="">
                        <mat-divider></mat-divider>
                        <div class="mt-20">
                            <div class="texto">{{textResultsBoxEntregables | translate}}</div>
                        </div>
                    </div>

                </div>
            </div>
            <!--RANKING-->
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto==1 && instituto==1 || tipoProducto==1 && instituto==2">
                <div class="mat-elevation-z2 p-20 m-20 tarjeta ranking" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="">
                        <!--<h1>{{infoAvanceConteo.avance.porcentaje}} %</h1>-->
                        <h3>{{resultadoRanking | number:'1.0-0'}} {{'PORTAL.COLAB' | translate}}</h3>

                    </div>
                    <div class="">
                        <mat-divider></mat-divider>
                        <div class="mt-20">
                            <div class="texto">{{textResultsBoxRanking | translate}}</div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <!-- <div   class="mt-20" fxLayout="row" fxLayoutAlign="end">
        <div class="" fxLayout="column" fxLayoutAlign="start end" fxFlex="50">
        <button mat-raised-button class="mb-20 primary" (click)="infoExcel()">
      {{'PORTAL.EXCEL.NOMBOTON' | translate}}
        <mat-icon class="ml-20">cloud_download</mat-icon>
      </button>
    </div>
    </div> -->
        <ng-container *ngIf="empresasExisten2">
            <mat-form-field appearance="outline">
                <mat-label>{{'PORTAL.TIPO-PERSONAL.TIPO'| translate}}</mat-label>
                <mat-select [(value)]="tipoPersonalSeleccionado" (selectionChange)="selecTipoDePortal()">
                    <mat-option *ngFor="let tipoPersonal of tipoPersonal" [value]="tipoPersonal.value">
                        {{'PORTAL.TIPO-PERSONAL.'+tipoPersonal.value | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>


        <div class="" fxLayout="row" fxLayoutAlign="start stretch" *ngIf="datosEncontrados">
            <canvas baseChart fxFlex="80" height="150px" [labels]="barChartLabels" [datasets]="bubbleChartData" [options]="bubbleChartOptions" [colors]="bubbleChartColors" [legend]="bubbleChartLegend" [chartType]="bubbleChartType">
      </canvas>
        </div>



        <div class="" fxLayout="column" fxLayoutAlign="start stretch">
            <!-- <h1>Filtros</h1> -->
            <div class="" fxLayout="row" fxLayoutAlign="center">
            </div>
            <div class="" fxLayout="row" fxLayoutAlign="space-between">
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="100">
                        <mat-label>{{'PORTAL.SELECTFPLA' | translate}}</mat-label>
                        <!-- <mat-select formControlName="institute"> -->
                        <mat-select>
                            <mat-option *ngFor="let filtro of listaFiltros" [value]="filtro.id" (click)="getConteosF2Empresas(filtro.id,filtro.nombre )">
                                <!-- <mat-option > -->
                                <!-- {{institute.regionInstituto}} -->
                                {{'PORTAL.FILTROS.'+filtro.id | translate}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                        <mat-error>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO_REQUIRED' | translate}}</mat-error>
                    </mat-form-field>

                </div>
            </div>

        </div>


        <div class="" fxLayout="column" fxLayoutAlign="start stretch">

            <div class="" fxLayout="row" fxLayoutAlign="center">
                <h1>{{nombre}}</h1>
            </div>
            <div class="" fxLayout="column" fxLayoutAlign="space-between">
                <ng-container *ngIf="cargandoFiltros">
                    <div class="mt-20" fxLayout="column" fxLayoutAlign="space-between center">
                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                        <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
                    </div>
                </ng-container>
                <ng-container *ngIf="filtrados2empresas && !cargandoFiltros">

                    <div *ngFor="let resultados of filtrados2empresas;" fxLayout="column" fxLayoutAlign="" fxFlex="50">
                        <ng-container *ngIf="!mensaje">
                            <h3>{{resultados.filtro}}</h3>

                            <div class="" fxLayout="row" fxLayoutAlign="start start">
                                <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="90">
                                    <mat-progress-bar *ngIf="!validarIzzi && selectInstituto!=14" class="prro" mode="buffer" value="{{resultados.porcentaje }}"></mat-progress-bar>
                                    <h4 class="mt-0 mb-10 midText">{{'PORTAL.TBARRAPROGRESO' | translate}}: {{resultados.porcentaje | number:'1.0-0'}}%</h4>
                                </div>
                                <h3 class="mt-0 ml-10 tamañoletra">[{{resultados.endUsers}}/{{resultados.totalUsers}}]</h3>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="mensaje">
                    <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center">
                        <h1 class="h1 secondary-text">
                            <p class="textoN">{{'PORTAL.NO-INFO' | translate}}</p>
                        </h1>
                    </div>
                </ng-container>
            </div>


        </div>

    </ng-container>

</div>
<div id="download">
  <img #canvas >
  <a #downloadLink></a>
</div>
